export const REQUEST_REGISTER = 'REQUEST_REGISTER'
export const RECEIVE_REGISTERED_USER = 'RECEIVE_REGISTERED_USER'
export const REGISTRATION_FAILED = 'REGISTRATION_FAILED'

export const REQUEST_AUTHENTICATE = 'REQUEST_AUTHENTICATE'
export const RECEIVE_USER = 'RECEIVE_USER'
export const AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE'
export const RECEIVE_TOKEN = 'RECEIVE_TOKEN'
export const RECEIVE_CHECK_AUTH_FAILED = 'RECEIVE_CHECK_AUTH_FAILED'
export const REQUEST_CHECK_AUTH = 'REQUEST_CHECK_AUTH'
export const LOGOUT = 'LOGOUT'

export const RECEIVE_ROLES = 'RECEIVE_ROLES';
export const REQUEST_ROLES = 'REQUEST_ROLES';

export const RECEIVE_USERS = 'RECEIVE_USERS';
export const RECEIVE_ENTITIES = 'RECEIVE_ENTITIES';

export const SAVE_ROLE = 'SAVE_ROLE';

export const SAVE_MY_STATE = 'SAVE_MY_STATE';

export const USER_DETAIL = 'USER_DETAIL';
